var t = /* @__PURE__ */ ((e) => (e.Between = "between", e.End = "end", e.Start = "start", e))(t || {});
export {
  t as NavbarHorizontalAlign
};
